import React, { useState } from "react";
import { Modal, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ImageModalProps {
    open: boolean; // Indica si el modal está abierto o cerrado
    handleClose: () => void; // Función para cerrar el modal
    imageUrl: string; // URL de la imagen a mostrar
  }
  const ImageModal: React.FC<ImageModalProps> = ({ open, handleClose, imageUrl }) => {
    return (
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            outline: "none",
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={imageUrl}
            alt="Imagen en grande"
            style={{ maxWidth: "90vw", maxHeight: "90vh" }}
          />
        </Box>
      </Modal>
    );
  };
  
  export default ImageModal;